// Environment based settings
export const isDev = process.env.NODE_ENV === 'development';
export const apiBase = isDev ? 'http://localhost:8086/' : 'https://api-carnivora.rpsonline.nl/';
export const navigationUseFragments = isDev;
